import * as React from 'react';
import Link from '@mui/joy/Link';

/**
 * Roteador mínimo baseado na History API. O app.yaml já devolve index.html
 * para qualquer rota, então não é preciso hash nem dependência extra.
 */
export const routes = {
  home: '/',
  privacy: '/privacidade',
  terms: '/termos',
};

const ROUTE_EVENT = 'easycart:routechange';

function normalize(pathname: string) {
  const path = pathname.replace(/\/+$/, '').toLowerCase();
  return path === '' ? '/' : path;
}

export function navigate(to: string) {
  if (normalize(to) !== normalize(window.location.pathname)) {
    window.history.pushState({}, '', to);
    window.dispatchEvent(new Event(ROUTE_EVENT));
  }
  window.scrollTo(0, 0);
}

export function useRoute() {
  const [route, setRoute] = React.useState(() => normalize(window.location.pathname));

  React.useEffect(() => {
    const sync = () => setRoute(normalize(window.location.pathname));
    window.addEventListener('popstate', sync);
    window.addEventListener(ROUTE_EVENT, sync);
    return () => {
      window.removeEventListener('popstate', sync);
      window.removeEventListener(ROUTE_EVENT, sync);
    };
  }, []);

  return route;
}

type RouterLinkProps = React.ComponentProps<typeof Link> & { to: string };

/** Link que navega sem recarregar a página, mas continua sendo um <a href> real. */
export function RouterLink({ to, onClick, ...props }: RouterLinkProps) {
  return (
    <Link
      {...props}
      href={to}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event);
        // Preserva abrir em nova aba (ctrl/cmd/shift/clique do meio).
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }
        event.preventDefault();
        navigate(to);
      }}
    />
  );
}
